/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/ChecklistSection.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Displays a checklist section and renders all
 * checklist items belonging to the section.
 *
 ******************************************************************************/

import React, { useMemo, useState } from "react";
import ChecklistItem from "./ChecklistItem";

export default function ChecklistSection({

    section,

    disabled = false,

    onResponseChange,

    onRemarksChange,

    onPhotoClick,

    onAttachmentClick,

    onObservationClick,

}) {

    // ==========================================================
    // STATE
    // ==========================================================

    const [expanded, setExpanded] = useState(

        section.expanded ?? true

    );

    // ==========================================================
    // PROGRESS
    // ==========================================================

    const progress = useMemo(() => {

        const total = section.items.length;

        const completed = section.items.filter(

            (x) => x.completed

        ).length;

        const mandatoryPending = section.items.filter(

            (x) =>

                x.mandatory &&

                !x.completed

        ).length;

        return {

            total,

            completed,

            mandatoryPending,

            percentage:

                total === 0

                    ? 0

                    : Math.round(

                        (completed / total) * 100

                    ),

        };

    }, [section.items]);

    // ==========================================================
    // RENDER
    // ==========================================================

    return (

        <div className="card shadow-sm border-0 mb-4">

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <div
                className="card-header bg-white"
                style={{ cursor: "pointer" }}
                onClick={() => setExpanded(!expanded)}
            >

                <div className="d-flex justify-content-between align-items-center">

                    <div>

                        <button
                            className="btn btn-link btn-sm p-0 me-2"
                            type="button"
                        >

                            <i
                                className={
                                    expanded
                                        ? "fas fa-chevron-down"
                                        : "fas fa-chevron-right"
                                }
                            />

                        </button>

                        <strong>

                            {section.name}

                        </strong>

                    </div>

                    <div className="text-end">

                        <div>

                            <strong>

                                {progress.completed}

                            </strong>

                            {" / "}

                            <strong>

                                {progress.total}

                            </strong>

                            {" Completed"}

                        </div>

                        <small className="text-muted">

                            Mandatory Pending :

                            {" "}

                            {progress.mandatoryPending}

                        </small>

                    </div>

                </div>

                <div className="progress mt-3">

                    <div

                        className="progress-bar bg-success"

                        style={{

                            width:

                                `${progress.percentage}%`

                        }}

                    >

                        {progress.percentage}%

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* BODY */}
            {/* ====================================================== */}

            {

                expanded && (

                    <div className="card-body">

                        {

                            section.items.map((item) => (

                                <ChecklistItem

                                    key={item.id}

                                    item={item}

                                    disabled={disabled}

                                    onResponseChange={onResponseChange}

                                    onRemarksChange={onRemarksChange}

                                    onPhotoClick={onPhotoClick}

                                    onAttachmentClick={onAttachmentClick}

                                    onObservationClick={onObservationClick}

                                />

                            ))

                        }

                    </div>

                )

            }

        </div>

    );

}